var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "com-dimensional-box" },
    [
      _vm._l(_vm.list, function (item) {
        return [
          item.rangeType === 5 && _vm.isForm
            ? [
                _c("rt-model", {
                  key: item.id,
                  ref: "rtModel",
                  refInFor: true,
                  attrs: {
                    type: item.itemType,
                    rtDetails: _vm.rtModelDetail,
                    defaultCheckedKeys: _vm.checkedKeys,
                  },
                  on: { changeChecks: _vm.getCheckList },
                }),
              ]
            : item.rangeType === 4 && _vm.isForm
            ? [
                _c("skill-model", {
                  key: item.id,
                  attrs: {
                    isForm: _vm.isForm,
                    type: item.itemType,
                    jqDetails: _vm.skillModelDetail,
                    defaultCheckedKeys: _vm.defaultCheckedKeys,
                  },
                }),
              ]
            : (item.rangeType === 3 && _vm.isForm && !item.ruleId) ||
              (!_vm.isForm && item.ruleId)
            ? [
                _c(
                  "yxt-checkbox",
                  {
                    key: item.id,
                    staticClass: "mb8",
                    attrs: {
                      label: item.id,
                      disabled: _vm.defaultCheckedKeys.includes(item.id),
                    },
                    model: {
                      value: item.checked,
                      callback: function ($$v) {
                        _vm.$set(item, "checked", $$v)
                      },
                      expression: "item.checked",
                    },
                  },
                  [
                    _c(
                      "yxt-popover",
                      {
                        attrs: {
                          placement: "bottom",
                          trigger: "hover",
                          "max-width": 960,
                        },
                      },
                      [
                        item.show && item.ruleId
                          ? _c("talent-dimension-detail", {
                              key: item.id,
                              attrs: { ruleId: item.ruleId },
                            })
                          : _vm._e(),
                        _c(
                          "div",
                          {
                            staticClass: "com-dimensional-box__text",
                            attrs: { slot: "reference" },
                            on: {
                              mouseenter: function ($event) {
                                if ($event.target !== $event.currentTarget) {
                                  return null
                                }
                                return _vm.show(item)
                              },
                            },
                            slot: "reference",
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(item.itemValue) +
                                "\n          "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }